import { IMonth, IEvent, IDay, IProduction } from "../interfaces";
import { IRestrictedRange, composeFilterFunction } from "./compose-filter-function";
import { FilterState } from "../classes/filter-state";
import { ICalendarOptions, IDateRange } from "../classes/calendar";
import moment = require("moment");
import { groupBy } from "lodash";

/**
 * Compose a filter function based on filter state, and return a filtered array of events.
 */
export function filterEvents(events: IMonth<IEvent>[], range: IRestrictedRange, filterFunction: (event) => boolean, ...filters: FilterState<IEvent>[]): [IMonth<IEvent>[], number] {

    // This code is terrible. DO NOT COPY TO ANOTHER SITE. This is a terrible mix of two working filter systems
    const [filter, filterHash] = composeFilterFunction(range, ...filters);
    const filteredEvents: IMonth<IEvent>[] = [];

    events.forEach(month => {
        const filteredMonth: IMonth<IEvent> = {
            monthMoment: month.monthMoment,
            events: {
                days: [],
                productions: [],
                allDays: []
            }
        };

        filteredMonth.events.productions = month.events.productions.filter(filterFunction);
        let eventsForSpecificMonth = [];
        month.events.days.forEach(day => {
            const filteredDay: IDay<IEvent> = {
                date: day.date,
                events: day.events.filter(filterFunction) || []
            };
            if (filteredDay.events && filteredDay.events.length > 0)
                eventsForSpecificMonth.push(...filteredDay.events)
            filteredMonth.events.days.push(filteredDay);
        });
        filteredMonth.events.allDays = eventDays(filteredMonth.events.days, eventsForSpecificMonth);
        filteredEvents.push(filteredMonth);
    });

    return [filteredEvents, filterHash];
}

export function eventDays<T extends IEvent>(days: Array<IDay<T>>, events?: Array<T>): Array<IDay<T>> {
    if (events.length > 0) {
        let range = { start: moment(events[0].eventDate).toDate(), end: moment(events[events.length - 1].eventDate).toDate() };
        let days = interpolateDays(range).map((d) => { return { date: d } });

        if (events) {
            return addEvents<T>(days, events);
        }
        return days;
    } else {
        return [];
    }
}
export function addEvents<T extends IEvent>(days: Array<IDay<T>>, events: Array<T>): Array<IDay<T>> {
    const groupedEvents = groupBy(events, e => moment(e.eventDate).startOf('day').format('YYYYMMDD'));

    return days.map(d => {
        const date = moment(d.date).startOf('day').format('YYYYMMDD');
        const events = groupedEvents[date];

        d.events = events ? events : [];
        return d;
    })
}

export function interpolateDays(range: IDateRange): Array<Date> {
    let dates = [];
    let current = moment(range.start).startOf('day');
    let end = moment(range.end).startOf('day');

    if (end < current) {
        return [];
    }

    while (current <= end) {
        dates.push(current.clone().toDate());
        current.add(1, 'days');
    }

    return dates;
}
